import { CountryCode } from "~shared/constants";

export const CONTENT_PADDING_OTHER_OFFERS = 50;
export const DEFAULT_HEIGHT_OTHER_OFFERS = 305;
export const HEIGHT_OFFSET_MOBILE_TWO_OFFERS = 85;
export const HEIGHT_OFFSET_OTHER_OFFERS = 82;
export const HEIGHT_OFFSET_OTHER_OFFERS_TABLET = 57;
export const HEIGHT_OFFSET_OTHER_OFFERS_MOBILE = 110;
export const SHIPPING_HEIGHT_OFFSET = 25;
export const HEIGHT_OFFSET_TABLET_TWO_OFFERS = 37;
export const BUYBOX_STICKY = 'newBuybox-sticky';
export const BUYBOX_NON_STICKY = 'newBuybox-non-sticky';
export const CALLBACK_ATTRIBUTE = 'int_callback';

export const CALLBACK_LINKS = {
  [CountryCode.Germany]: 'https://calendly.com/metro-markets/15-min-beratung',
  [CountryCode.France]: 'http://calendly.com/metro-markets/rdv-15-minutes'
}